export const server = `
import { bootstrap, JobQueueService, runMigrations } from '@vendure/core'
import { config } from './vendure-config'

/**
 * Bootstrap the Vendure server with migrations
 */
async function startServer() {
  console.log('🔄 Running database migrations...')
  await runMigrations(config)
  
  console.log('🚀 Starting Vendure server...')
  const app = await bootstrap(config)
  
  console.log('⚡ Starting job queue...')
  const jobQueueService = app.get(JobQueueService)
  await jobQueueService.start()
  
  console.log('✅ Vendure server started successfully!')
  console.log(\`🌐 Admin UI: http://localhost:\${config.apiOptions.port + 2}/admin\`)
  console.log(\`🛍️  Shop API: http://localhost:\${config.apiOptions.port}/shop-api\`)
  console.log(\`⚙️  Admin API: http://localhost:\${config.apiOptions.port}/admin-api\`)
}

startServer().catch(err => {
  console.error('❌ Error starting server:', err)
  process.exit(1)
})
`
